// extracted by mini-css-extract-plugin
module.exports = {"body":"body__body___1HSIF"};